module.exports = {
  //LIVE
  // ServicePath: "https://api.controla.in",
  ServicePath: "https://apiqa.controla.in",
  
  // Demo School
  websiteSetting: {
    WebUrl: "http://controla.in",
    AdmissionWebUrl: "https://admissionschool.controla.in",
    Logo: "../../../../img/logo_demo.png",
    PrintLogo: "../../../../img/logo_demo.png",
    ThanksImg: ``,
    PaymetnAcknowledgement: "Payment Acknowledgement",
    SignUpMsgModal: `<strong>Mobile Number is Already Registered</strong><span>Your login credentials has been sent on your registered mobile number and email.<br/>To proceed with admission process login with the credentials received</span> <center>
      <a href="https://admissionschoool.controla.in/Login" >
        <button
          type="button"
          class="btn btn-danger btn-lg theme-btn"
        >
        <i class="fa fa-key" aria-hidden="true"></i>
          Login here..
        </button>
      </a>
    </center>`,
    NewSignUpMsgModal: `<strong>Thank you for showing interest with us!!!.</strong> <span>Your login credentials has been sent on your registered mobile number and email.<br/>To proceed with admission process login with the credentials received</span> <center>
    <a href="https://admissionschoool.controla.in/Login" >
      <button
        type="button"
        class="btn btn-danger btn-lg theme-btn"
      >
      <i class="fa fa-key" aria-hidden="true"></i>
        Login here..
      </button>
    </a>
  </center>`,
    SignUpSmsTxt: "Thank you for SignUp. Your credentials are <br/>",
    EnquiryMsgModal: `<strong>Thank you for Enquiry.</strong><span> Thank you for showing interest in Sumandeep Vidyapeeth. <br /> We will get back shortly. <br/>Email:- info@controla.in</span>`,
    EmailHeaderContent: `<br/><br/>Thank you for showing interest for admission in Sumandeep Vidyapeeth.<br/><br/>
      For logging in to your Sumandeep Vidyapeeth account to fill the application form, please click on
      <a href="https://admissionschoool.controla.in/Login" target="_blank">https://admissionschoool.controla.in/Login </a>`,
    EmailFooterContent: `<br/><br/>Meanwhile, please visit  <a href="http://controla.in" target="_blank">www.controla.in</a> for more details. For any clarification, <br/><br/>
        Email:- <a href="mailto:info@controla.in" target="_top">info@controla.in</a> <br/><br/> Thanking you. <br/><br/>
        Admission Cell<br/> Sumandeep Vidyapeeth`,
    signUpContent: "sud",
    Signupintroduction: ``,
    EnquiryContent: `<div class="regformLeftBg bgNuv"><h3 class="text-center mb-3">FOR NEW APPLICANTS / FRESHERS</h3><div class="onlineNote"><p class="mb-2"><strong>Applicant must ensure that he/she has the following information in hand before proceeding for ‘Online Application for Admission’ procedure:</strong></p><ul><li><p class="mb-2">Applicant’s functional <strong> E-MAIL ID </strong> and<strong> MOBILE NUMBER. </strong> [They will be used for all future communications from the School]</p></li><li><p class="mb-2"><strong>SCANNED COPY OF PASSPORT SIZE COLOR PHOTOGRAPH</strong> of the Applicant</p></li><li><p class="mb-2">Applicant’s <strong> Date of Birth Proof </strong>(Providing Applicant’s Date of Birth Proof is mandatory for successful completion of the application)</p></li><li><p class="mb-2">Correct details of Residential address / Address for communication with Proof</p></li><li><p class="mb-2">Necessary Mark-sheets &amp; Certificates of last qualifying exam</p></li><li><p class="mb-2">Caste Certificate (If Applicable)</p></li></ul></div></div>`,
  },

  // Navrachana University
  // websiteSetting: {
  //   WebUrl: "http://nuv.ac.in",
  //   AdmissionWebUrl: "https://admission.nuv.ac.in",
  //   Logo: "../../../../img/nuv_logo.png",
  //   PrintLogo: "../../../../img/nuv_header.png",
  //   ThanksImg: ``,
  //   PaymetnAcknowledgement: "Navrachana University Payment Acknowledgement",
  //   SignUpMsgModal: `<strong>Mobile Number is Already Registered</strong><span>Your login credentials has been sent on your registered mobile number and email.<br/>To proceed with admission process login with the credentials received</span> <center>
  //     <a href="https://admission.nuv.ac.in/Login" >
  //       <button
  //         type="button"
  //         class="btn btn-danger btn-lg theme-btn"
  //       >
  //       <i class="fa fa-key" aria-hidden="true"></i>
  //         Login here..
  //       </button>
  //     </a>
  //   </center>`,
  //   NewSignUpMsgModal: `<strong>Thank you for showing interest with us!!!.</strong> <span>Your login credentials has been sent on your registered mobile number and email.<br/>To proceed with admission process login with the credentials received</span> <center>
  //   <a href="https://admission.nuv.ac.in/Login" >
  //     <button
  //       type="button"
  //       class="btn btn-danger btn-lg theme-btn"
  //     >
  //     <i class="fa fa-key" aria-hidden="true"></i>
  //       Login here..
  //     </button>
  //   </a>
  // </center>`,
  //   SignUpSmsTxt: "Thank you for SignUp. Your credentials are <br/>",
  //   EnquiryMsgModal: `<strong>Thank you for Enquiry.</strong><span> Thank you for Enquiry. <br /> Our team will get back to you shortly.</span>`,
  //   EmailHeaderContent: `<br/><br/>Thank you for showing interest for admission in Navrachana University.<br/>
  //     For logging in to your Navrachana University account to fill the application form, please click on
  //     <a href="https://admission.nuv.ac.in/Login" target="_blank">https://admission.nuv.ac.in/Login</a>`,
  //   EmailFooterContent: `Thanking you.<br/><br/>`,
  //   signUpContent: "nvu",

  //   LoginContent: `<div class="regformLeftBg bgNuv">
  //     <h3 class="mb-3">Contact Details</h3>
  //     <p class="mb-2"><b>Days :</b> Monday To Friday</p>
  //     <p class="mb-2"><b>Time :</b> 9:00AM To 5:00PM</p>
  //     <p class="mb-2"><b>Contact Email</b> : admission@nuv.ac.in</p>
  //     <p class="mb-2"><b>Contact Number</b> : (0265) 2617285 - 89 </p>
  //     <p class="mb-2"><b>Mobile Number</b> : 9737071700, 701 </p>
  //   </div>`,

  //   Signupintroduction: ``,

  //   EnquiryContent: `<div class="regformLeftBg bgNuv ">
  //        <h3 class="text-center">Admission (2019-20)</h3>
  //        <p>
  //          <b>Application fee: </b>
  //          <br />
  //          All Program: Rs.1000/- <br />
  //          For BArch Program: Rs.350/-
  //        </p>
  //        <p class="mb-1">
  //          <b>BTech Program:</b>
  //          <br /> Candidates must register in ACPC. Admission to 75%
  //          seats (Gujarat Seats) of the Program will be through ACPC
  //          (Admission Committee for Professional Courses), Government of
  //          Gujarat on basis of the merit list prepared by the ACPC. The
  //          remaining 25% seats (All out-of-the-state applications) will
  //          be filled from the all India candidates (including Gujarat) on
  //          the basis of percentile score in JEE (Main) examination.
  //        </p>
  //        <p class="mb-1">
  //          <b>BArch Program:</b>
  //          <br /> Candidates must register in ACPC. Admission to 30 Open
  //          Seats of the program will take place through the ACPC
  //          (Admission Committee for Professional Courses) of the
  //          Government of Gujarat. Admission to 10 Management and NRI/NRI
  //          sponsored seats are offered by the Navrachana University as
  //          per the guidelines of ACPC.
  //        </p>
  //        <p class="mb-1">
  //          <b>MBA Program:</b>
  //          <br /> Candidates must register in ACPC. Admission to 60 seats
  //          of the Program will be through ACPC (Admission Committee for
  //          Professional Courses), Government of Gujarat on basis of the
  //          merit list prepared by the ACPC.
  //        </p>
  //        <p class="mb-1">
  //          <b>All other Programs:</b> Candidates are required to appear
  //          for entrance exam and/or interview on the basis of eligibility
  //          criteria decided by the program.
  //        </p>
  //        <div class="onlineNote">
  //          <p class="mb-1">
  //            <strong>Note:</strong>
  //          </p>
  //          <ul>
  //            <li>
  //              <p class="mb-1">
  //                Candidates are required to fill the name as it appears
  //                in the qualifying examination mark sheet.
  //              </p>
  //            </li>
  //            <li>
  //              <p class="mb-1">
  //                Please mention your correct mobile no and email ID for
  //                any future communication.
  //              </p>
  //            </li>
  //          </ul>
  //        </div>
  //        <center>
  //          <a href="http://nuv.ac.in" target="_blank">
  //            <button
  //              type="button"
  //              class="btn btn-danger btn-lg theme-btn"
  //            >
  //              <i class="fa fa-globe"></i>
  //              Go to Website
  //            </button>
  //          </a>
  //        </center>
  //      </div>`
  // },

  // UAT
  authorizedURL: "http://localhost:3003",
};



// WEBPACK FOOTER //
// ./src/config/prod.js